import React, { useState, useCallback } from 'react';
import store from 'store';

import { rootDomainUrl } from '../../utils/url';

import { Container, Items, Item, Link } from './style';

const STORE_KEY = 'accepts-cookies';

const CookieBanner = () => {
  const [cookie, setCookie] = useState(store.get(STORE_KEY));

  const handleOnAccept = useCallback(() => {
    store.set(STORE_KEY, true);

    setCookie(true);
  }, []);

  if (cookie) {
    return null;
  }

  return (
    <Container>
      <Items>
        <Item>
          {'🍪 When using this website you agree to be bound by our '}
          <a href={rootDomainUrl('/cookie-notice')} rel="noopener noreferrer" target="_blank">
            cookie notice
          </a>
          .
        </Item>
        <Item>
          <Link data-cy="cookie-banner-btn" onClick={handleOnAccept} type="link">
            Accept
          </Link>
        </Item>
      </Items>
    </Container>
  );
};

export default CookieBanner;
